import { useMutation } from '@tanstack/react-query';
import { notesService } from '../api/notes.service';
import type { InterpretNoteAsTaskRequest } from '../types';

/**
 * Mutation hook to interpret a note as a task using AI.
 * Returns the interpreted fields to pre-fill the convert-to-task dialog.
 */
export function useInterpretNoteAsTask(noteId: string) {
  return useMutation({
    mutationFn: (payload: InterpretNoteAsTaskRequest) =>
      notesService.interpretNoteAsTask(noteId, payload),
  });
}
